import { BasicEvent } from "../../../planera/events/BasicEvent";
export class ArbetsorderIntressentArbetsorderChangedMessage extends BasicEvent {
    anvandareId: number;
    arbetsorderId: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "ArbetsorderIntressentArbetsorderChangedMessage";
}
